import { ConversationsPayload } from "../interfaces/api/conversation-payload";
import { GetFacebookMessagesResponse } from "../interfaces/api/get-facebook-messages";
import { GetInstagramConversationsResponse } from "../interfaces/api/get-instagram-conversations";
import { Message } from "../interfaces/conversations.interface";
import {
  GetInstagramMessagesResponse,
  MessagesPayload,
} from "../interfaces/api/get-instagram-messages";
import { GetWhatsappMessagesResponse } from "../interfaces/api/get-whatsapp-messages";
import {
  extractMessagesArray,
  normalizeSocialMessage,
} from "./normalize-messages";
import {
  MessagePayload,
  PostInstagramMessageResponse,
} from "../interfaces/api/post-instagram-message";

export const socialChatMapper = {
  mapResponseToConversations({
    payload,
  }: GetInstagramConversationsResponse): ConversationsPayload {
    return {
      active: payload.active,
      archived: payload.archived,
      inTrash: payload.inTrash,
    };
  },

  mapResponseToMessages(
    response:
      | GetInstagramMessagesResponse
      | GetFacebookMessagesResponse
      | GetWhatsappMessagesResponse
  ): MessagesPayload {
    const r = response as {
      payload?: { messages?: Message[] };
      messages?: Message[];
    };
    const direct = r.payload?.messages ?? r.messages;
    if (Array.isArray(direct) && direct.length > 0) {
      return {
        messages: direct.map((item, i) => normalizeSocialMessage(item, i)),
      };
    }
    /** Fallback solo si el body viene en otra forma (p. ej. otro anidamiento). */
    const extracted = extractMessagesArray(response);
    return {
      messages: extracted.map((item, i) => normalizeSocialMessage(item, i)),
    };
  },
  mapResponseToMessage(response: PostInstagramMessageResponse): MessagePayload {
    return { message: response.payload.message, id: response.payload.id };
  },
};
